import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/billing', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const BillingAPI = {

  getBuyerAccountPayments() {
    const url = `admin/payments/buyer`
    const result = httpClient.get(url)
    return result
  },

  getSellerAccountPayments() {
    const url = `admin/payments/seller`
    const result = httpClient.get(url)
    return result
  },

  async getSellersPaymentHistory(accountId = null) {
    const url = `admin/payments/paid/seller?${!accountId ? '' : `accountId=${accountId}`}`
    return await httpClient.post(url, {})
  },

  async getBuyersPaymentHistory(accountId = null) {
    const url = `admin/payments/paid/buyer?${!accountId ? '' : `accountId=${accountId}`}`
    return await httpClient.post(url, {})
  },

  generateDownloadLink({ accountId, invoiceId }) {
    const url = `admin/payments/invoice/${accountId}/${invoiceId}`
    return httpClient.get(url)
  },

  async getPaymentDetails({ accountId, invoiceId }) {
    const url = `admin/payments/${accountId}/${invoiceId}`
    return await httpClient.get(url)
  },

  async registerBuyerPayment({ accountId, invoiceId, data }) {
    const url = `admin/payments/buyer/${accountId}/${invoiceId}/pay`
    return await httpClient.post(url, data)
  },

  async registerSellerPayout({ accountId, invoiceId, data }) {
    const url = `admin/payments/seller/${accountId}/${invoiceId}/payout`
    return await httpClient.post(url, data)
  },

  markInvoiceAsPaid({ data }) {
    const url = `admin/payments/${data.accountId}/${data.invoiceId}/mark-paid`
    return httpClient.post(url, {notes: data.notes})
  },

  runInvoiceVerification({ accountId, invoiceId }) {
    const url = `admin/payments/${accountId}/${invoiceId}/verify`
    return httpClient.post(url, {})
  },

  async previewInvoice({ accountId, startDate, endDate, invoiceId }) {
    const url = `admin/payments/${accountId}/preview-invoice`
    const data = {}
    if (startDate) {
      data.startDate = startDate
    }
    if (endDate) {
      data.endDate = endDate
    }
    if (invoiceId) {
      data.invoiceId = invoiceId
    }
    return await httpClient.post(url, data)
  },

  getSystemAccountSummary({includeTestOnly}) {
    const url = `admin/accounts/summary/?includeTestOnly=${includeTestOnly}`
    return httpClient.get(url)
  },

  getSystemAccountGrossMargin({startDate, endDate, includeTestOnly}) {
    const url = `admin/accounts/gross-margin/?startDate=${startDate}&endDate=${endDate}&includeTestOnly=${includeTestOnly}`
    return httpClient.get(url)
  },

  async getAccountOutstandingBalance(accountId) {
    const url = `admin/payments/${accountId}/outstanding-balance`
    return await httpClient.get(url)
  },

  async registerGenericPayment({ accountId, paymentAmount, applyCascade, description }) {
    const url = `admin/payments/buyer/${accountId}/register-payment`
    return await httpClient.post(url, {
      paymentAmount,
      applyCascade,
      description
    })
  },

  async closeBillingCycle({ accountId, endDate }) {
    const url = `admin/payments/${accountId}/close-billing-cycle`
    return await httpClient.post(url, { endDate })
  },

  async regenerateInvoice({ accountId, invoiceId }) {
    const url = `admin/payments/${accountId}/${invoiceId}/regenerate`
    return await httpClient.post(url, {})
  },

  async deleteInvoice({ accountId, invoiceId }) {
    const url = `admin/payments/${accountId}/${invoiceId}`
    return await httpClient.delete(url)
  },

  async generateCollectionStatement({ accountId }) {
    const url = `admin/payments/${accountId}/collection-statement`
    return await httpClient.post(url, {})
  },

  async markInvoiceAsIssued({ accountId, invoiceId }) {
    const url = `admin/payments/${accountId}/${invoiceId}/mark-as-issued`
    return await httpClient.post(url, {})
  }
}

export default BillingAPI
